var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-avatar',_vm._g(_vm._b({staticClass:"pointer"},'v-avatar',_vm.$attrs,false),_vm.$listeners),[_c('v-img',{attrs:{"src":_vm.u(_vm.value).icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }